import defaultAttributes from '../defaultAttributes';

const Dumbbell = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm6.5 6.5 11 11' }],
    ['path', { d: 'm21 21-1-1' }],
    ['path', { d: 'm3 3 1 1' }],
    ['path', { d: 'm18 22 4-4' }],
    ['path', { d: 'm2 6 4-4' }],
    ['path', { d: 'm3 10 7-7' }],
    ['path', { d: 'm14 21 7-7' }],
  ],
];

export default Dumbbell;
